import React from 'react';
import { Content, SmallTitle } from './FeaturesStyles';
import ReadOnlySwitch from '../ReadOnlySwitch/ReadOnlySwitch';
import { ISession } from 'interfaces/session/ISession';

interface IProps {
  session?: ISession;
}

const Features: React.FC<IProps> = (props) => {
  const { session } = props;

  return (
    <>
      {!session ? null : (
        <Content>
          <SmallTitle>Features</SmallTitle>
          <ReadOnlySwitch label='Player Tracking enabled' checked={session.isPlayerTrackingEnabled} />
          <ReadOnlySwitch label='Post Process Player Tracking' checked={session.isPostProcessPlayerTracking} />
          <ReadOnlySwitch label='Video Capture enabled' checked={session.isVideoCaptureEnabled} />
          <ReadOnlySwitch label='Player Positioning enabled' checked={session.isPlayerPositioningEnabled} />
          <ReadOnlySwitch label='3D Spin enabled' checked={session.is3DSpinEnabled} />
          <ReadOnlySwitch label='Annotated' checked={session.isAnnotated} />
        </Content>
      )}
    </>
  );
};

export default Features;
